import { useMemo } from 'react';

import { EmploymentData } from '~/data/employee';
import { useEmployeeEmploymentData } from '~/data/employee/useEmployeeEmploymentData';
import { ProposalProps } from '~/data/proposals';
import { useSelectedEmployeeId } from '~/hooks/employee/useSelectedEmployeeId';

type PropsType = {
  proposal?: ProposalProps;
};

export const useEmployeeDataForProposal = ({ proposal }: PropsType) => {
  const { selectedEmployeeId } = useSelectedEmployeeId();
  const targetEmployeeId = useMemo(
    () => proposal?.targetId || selectedEmployeeId,
    [proposal, selectedEmployeeId],
  );

  const { employeeEmploymentData, ...employmentDataState } =
    useEmployeeEmploymentData();
  const employmentData: EmploymentData | undefined = useMemo(() => {
    return employeeEmploymentData.find(
      (employmentData) => employmentData.fEmplEmpId === targetEmployeeId,
    );
  }, [employeeEmploymentData, targetEmployeeId]);

  const currency = useMemo(
    () => employmentData?.fEmplCurrency || '?',
    [employmentData],
  );

  return {
    employmentData,
    ...employmentDataState,
    currency,
  };
};
